module.exports = __webpack_public_path__ + "img/icon-faq.3c32bc1d.svg";